"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsControlsListStyles_1 = __importDefault(require("./valueIsControlsListStyles"));
const valueIsFunctionsEvaluatedListOptions_1 = __importDefault(require("./valueIsFunctionsEvaluatedListOptions"));
const valueIsFunctionsListModifications_1 = __importDefault(require("./valueIsFunctionsListModifications"));
const valueIsNullUndefinedOrType_1 = __importDefault(require("./valueIsNullUndefinedOrType"));
const valueIsShapeAssertion_1 = __importDefault(require("./valueIsShapeAssertion"));
const valueIsString_1 = __importDefault(require("./valueIsString"));
const valueIsUndefinedOrType_1 = __importDefault(require("./valueIsUndefinedOrType"));
const valueIsFunctionsEvaluatedListInstructions = (0, valueIsShapeAssertion_1.default)({
    listControlId: (0, valueIsNullUndefinedOrType_1.default)(valueIsString_1.default),
    listPageId: (0, valueIsNullUndefinedOrType_1.default)(valueIsString_1.default),
    listOptions: (0, valueIsUndefinedOrType_1.default)(valueIsFunctionsEvaluatedListOptions_1.default),
    listStyles: (0, valueIsUndefinedOrType_1.default)(valueIsControlsListStyles_1.default),
    modifications: (0, valueIsUndefinedOrType_1.default)(valueIsFunctionsListModifications_1.default),
});
exports.default = valueIsFunctionsEvaluatedListInstructions;
